export const isValidUrl = (str: string) => {
    let url;
    try {
        url = new URL(str);
    } catch (_) {
        return false;
    }
    return (
        (url.protocol === 'http:' || url.protocol === 'https:') &&
        (url.href == str || url.origin == str)
    );
};

export const checkDomainUrl = (url: string | string[] | undefined, whiteList: string[]) => {
    let redirectUrl = url;
    if (Array.isArray(redirectUrl)) redirectUrl = redirectUrl[0];
    if (!redirectUrl) return null;
    if (isValidUrl(redirectUrl)) {
        if (!whiteList.length) return null;
        const domain = new URL(redirectUrl).hostname;
        if (whiteList.includes(domain)) return redirectUrl;
        return null;
    } else {
        return redirectUrl;
    }
};
